/**
 * @class formFilter.
 *
 */
import { kebabCase, includes } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../common/containers/icon';
const addFilterProperty = (incomingStr, filterLabelName) => {
  let str = incomingStr;
  if (!includes(str, filterLabelName)) {
    // if (!str.includes(filterLabelName)) { // not IE11 compatible
    str += (str.length > 0 ? ', ' : '') + filterLabelName;
  }
  return str;
};
const filterString = (formFilter, filterDefinitions) => {
  let result = '';
  const {
    filters = {}
  } = formFilter;
  const filterTypes = Object.keys(filters);

  // loop over each form and add the FormType
  // associated with it.
  filterTypes.forEach(index => {
    // find index in filter definitions:
    const definition = filterDefinitions.find(def => def.index === index);
    if (definition !== undefined) {
      result = addFilterProperty(result, definition.title);
    }
  });
  return result;
};
const SavedFormFilter = ({
  formFilter,
  onRemove,
  onSelect,
  filterDefinitions
}) => {
  const clearStyle = {
    clear: 'both'
  };
  const handleSelect = () => onSelect(formFilter);
  const handleRemove = () => onRemove(formFilter);
  return /*#__PURE__*/React.createElement("div", {
    className: `boldOnHover t-rf-${kebabCase(formFilter.name)}`,
    "data-testid": `savedFormFilter-${kebabCase(formFilter.name)}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "t-rf-name",
    "data-testid": `selectSavedFormFilter-${kebabCase(formFilter.name)}`,
    onClick: handleSelect,
    onKeyPress: handleSelect,
    role: "link",
    tabIndex: 0
  }, formFilter.name), /*#__PURE__*/React.createElement("span", {
    "aria-label": `Delete Saved Filter ${formFilter.name}`,
    className: "float-md-right brandPrimary t-rf-delete",
    "data-testid": `savedFormFilterRemove-${kebabCase(formFilter.name)}`,
    onClick: handleRemove,
    onKeyPress: handleRemove,
    role: "link",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  })), /*#__PURE__*/React.createElement("div", {
    className: "t-rf-summary",
    onClick: handleSelect,
    onKeyPress: handleSelect,
    role: "link",
    style: clearStyle,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("small", null, filterString(formFilter, filterDefinitions))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    style: clearStyle
  }));
};
SavedFormFilter.propTypes = {
  onRemove: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  formFilter: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  filterDefinitions: PropTypes.arrayOf(PropTypes.shape({
    index: PropTypes.string,
    title: PropTypes.string
  })).isRequired
};
export default SavedFormFilter;